export default class AlMediaManagerDirectoryContentListing {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.timeout = this.injector.get('$timeout');
        this.translate = this.injector.get('$translate');
        this.fileSaver = this.injector.get('FileSaver');
        this.alert = this.injector.get('Alert');
        this.alert = this.injector.get('Alert');

        this.currentRequestIndex = 1;
        this.currentResetIndex = 1;
        this.keywordIndex = 1;
        this.loading = false;
        this.enableFileSelection = false;
        this.currentDirectoryInformation = {};

        this.directoryUuid = null;
        this.preSelectedFileUuid = null;

        this.currentSelectedFileUuid = null;
        this.currentSelectedFile = null;
        this.loadingCurrentSelectedFileInformation = false;

        this.sortingOptions = [
            {value: 'file_name', label: this.translate.instant('media.components.media-manager.sort.options.name')},
            {value: 'size', label: this.translate.instant('media.components.media-manager.sort.options.size')},
            {value: 'created_at', label: this.translate.instant('media.components.media-manager.sort.options.created_at')},
        ];

        this.sortingDirections = [
            {value: 'asc', label: this.translate.instant('media.components.media-manager.sort.directions.asc')},
            {value: 'desc', label: this.translate.instant('media.components.media-manager.sort.directions.desc')},
        ];

        this.currentSortOption = 'file_name';
        this.currentSortDirection = 'asc';

        this.currentView = 'grid';


        this.editPanelOpen = false;
        this.movePanelOpen = false;

        this.newFileName = '';
        this.moveToDirectory = '';

        this.directories = [];
        this._resetState();
    }

    $onInit() {
        this._initWatchers();
        this.loadNextPageContents();

        if (this.preSelectedFileUuid) {
            this.selectFile(this.preSelectedFileUuid);
        }

    }

    handleUploadSuccess(file) {
        this._resetState();
        this.loadNextPageContents()
            .then(() => {
                _.map(this.currentFiles, () => {
                    this.currentSelectedFileUuid = file.uuid;
                    this.currentSelectedFile = file;
                })
            });
    }

    handleFileSelection(file) {
        this.onFileSelection({
            file: this.currentSelectedFile
        });
    }

    loadNextPageContents() {
        const requestIndex = _.clone(++this.currentRequestIndex),
            resetIndex = _.clone(this.currentResetIndex);

        this.loading = true;
        const response = this.api.post('fp/media/files', this._getDataForFastPipeRequest()).then((response) => {
            if (resetIndex === this.currentResetIndex) {
                this.currentFiles = this.currentFiles.concat(response.data.data);

                if (requestIndex === this.currentRequestIndex) {
                    this.loading = false;
                    this.lastFastPipeInformation = {
                        pagination: response.data.pagination,
                        meta: response.data.meta
                    };
                }
            }
        });

        this.currentFastPipePage++;

        return response;
    }

    selectFile(fileUuid) {
        if (this.currentSelectedFileUuid === fileUuid) {
            this.currentSelectedFileUuid = null;
        } else {
            this.currentSelectedFileUuid = fileUuid;
        }

        this._refreshCurrentSelectedFileData();
    }

    downloadFile(file) {
        return this.api.get(
            file.url, {
                responseType: 'blob',
                ignoreLoadingBar: true
            }
        ).then(response => {
            return this.fileSaver.saveAs(
                new Blob([response.data],
                    {
                        type: response.headers('content-type')
                    }
                ),
                file.name
            );
        }).catch(
            error => {
                console.error('Download error', error);
                this.alert.animatedAlert(
                    this.translate.instant('general.alerts.download_error.title'),
                    this.translate.instant('general.alerts.download_error.content'),
                    'attention',
                    {
                        showCancelButton: false,
                        confirmButtonText: this.translate.instant('general.verbs.ok')
                    }
                )
            }
        );
    }

    loadDirectories() {
        this.api.get(`media/directories/as-tree`)
            .then(({data}) => {
                this.directories = data.data
            })
            .catch((e) => {
                this.alert.error(
                    this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                    this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                );
            })
    }

    moveFile(file) {
        this.updateFile(file, {moveTo: this.moveToDirectory});
    }

    updateFilename(file) {
        this.updateFile(file, {name: this.newFileName});
    }

    updateFile(file, data) {
        this.api.put(`media/files/${file.uuid}`, data)
            .then(() => {
                // this.alert.info(
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.title'),
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.content')
                // );
                this._resetState();
                this.loadNextPageContents();
            })
            .catch((e) => {
                // this.alert.error(
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                // );
            })
    }


    deleteFile(file) {
        this.alert.animatedAlert(
            this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.title'),
            this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.content'),
            'attention',
            {
                confirmButtonText: this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.confirm'),
                cancelButtonText: this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.cancel')
            }
        ).then(() => {
            this.api.delete(`media/files/${file.uuid}`)
                .then(() => {
                    this.alert.info(
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.title'),
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.content')
                    );
                    this._resetState();
                    this.loadNextPageContents();
                })
                .catch((e) => {
                    this.alert.error(
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                    );
                })
        });
    }

    switchSortOption(value) {
        this.currentSortOption = value;
        this._resetState(true)
        this.loadNextPageContents()
    }

    switchSortDirection(value) {
        this.currentSortDirection = value;
        this._resetState(true)
        this.loadNextPageContents()
    }

    switchView(value) {
        this.currentView = value;
    }

    // Private functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.directoryUuid;
        }, (newVal, oldVal) => {
            if (oldVal !== newVal) {
                this._resetState(false);
                this._loadDirectoryInformation();
                this.loadNextPageContents();
            }
        });

        this.scope.$watch(() => {
            return this.currentKeywordSearch;
        }, (newVal, oldVal) => {

            if (newVal !== oldVal) {
                const keyWordIndex = ++this.keywordIndex;
                this.timeout(() => {
                    if (keyWordIndex === this.keywordIndex) {
                        this._resetState(true);
                        this.loadNextPageContents();
                    }
                }, 450);
            }
        })
    }

    _resetState(keepKeyword, debugParam) {
        if (!keepKeyword) {
            this.currentKeywordSearch = '';
        }
        this.currentFiles = [];
        this.currentFastPipePage = 1;
        this.lastFastPipeInformation = null;
        this.currentSelectedFileUuid = null;
        this.currentSelectedFile = null;

        this.currentResetIndex++;

        this.editPanelOpen = false;
        this.movePanelOpen = false;
        this.newFileName = '';
        this.moveToDirectory = '';
    }

    _getDataForFastPipeRequest() {
        const dataForRequest = {
            filters: [
                {
                    field: 'type',
                    operator: '!=',
                    value: 'directory'
                },
                {
                    field: 'parent_file.uuid',
                    operator: '=',
                    value: this.directoryUuid
                }
            ],
            fields: [
                'uuid',
                'file_name',
                'size',
                'links',
                'created_at',
                'type'
            ],
            pagination: {
                perPage: 14,
                page: this.currentFastPipePage
            },
            sort: {
                [this.currentSortOption]: this.currentSortDirection,
            },
            keyword: this.currentKeywordSearch
        };

        if (!this.showHiddenFiles) {
            dataForRequest.filters.push({
                field: 'hidden',
                operator: '=',
                value: false
            });
        }

        return dataForRequest;
    }

    _loadDirectoryInformation() {
        if (!this.directoryUuid) {
            this.currentDirectoryInformation = {
                uuid: null,
                name: this.translate.instant('media.components.media-manager.root-directory-label')
            }
            return;
        }
        this.api.get(`media/files/${this.directoryUuid}`)
            .then(({data}) => {
                this.currentDirectoryInformation = data.data;
            })
            .catch((e) => {
                console.error('error while loading directory information', e);
            })
    }

    _refreshCurrentSelectedFileData() {
        this.currentSelectedFile = null;

        if (this.currentSelectedFileUuid) {
            this.loadingCurrentSelectedFileInformation = true;
            this.api.get(`media/files/${this.currentSelectedFileUuid}`)
                .then(({data}) => {
                    this.loadingCurrentSelectedFileInformation = false;
                    this.currentSelectedFile = data.data;
                })
        }
    }
}

AlMediaManagerDirectoryContentListing.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/directory-content-listing/controller.js